export const hubspotInit = (page: string, email: string) => {
  const _hsq = (window._hsq = window._hsq || []);
  _hsq.push(['identify', { email }]);
  _hsq.push(['setContentType', 'standard-page']);
  _hsq.push(['setPath', page]);
  _hsq.push(['trackPageView']);
};
